import { Box, BoxProps } from "@chakra-ui/react";
import { FiMinimize2 } from "react-icons/fi";

export const MinimizeIcon = (props: BoxProps) => {
  return <Box as={FiMinimize2} height="20px" width="20px" {...props} />;
};
